import { render } from "./are-you-sure.vue?vue&type=template&id=d2718328&scoped=true"
import script from "./are-you-sure.vue?vue&type=script&lang=js"
export * from "./are-you-sure.vue?vue&type=script&lang=js"

import "./are-you-sure.vue?vue&type=style&index=0&id=d2718328&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2424817344/src/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2718328"],['__file',"src/components/are-you-sure.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d2718328"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d2718328', __exports__)) {
    console.log('reload')
    api.reload('d2718328', __exports__)
  }
  
  module.hot.accept("./are-you-sure.vue?vue&type=template&id=d2718328&scoped=true", () => {
    console.log('re-render')
    api.rerender('d2718328', render)
  })

}


export default __exports__